import { Routes, Route } from 'react-router-dom';
import { CustomInvoicesPage } from './CustomInvoicesPage';
import { CustomInvoiceDetail } from './CustomInvoiceDetail';
import { CustomInvoicePrint } from './CustomInvoicePrint';

/**
 * Descendant routes for the custom-invoices surfaces, mounted from ONE
 * entry in app/router.tsx (`/billing/custom-invoices/*`) to keep the
 * shared router file's diff surface minimal:
 *
 *   /billing/custom-invoices            → list
 *   /billing/custom-invoices/:id        → detail
 *   /billing/custom-invoices/:id/print  → print-friendly A4 view
 *
 * All internal links use absolute paths, so route-relative resolution
 * quirks under the splat mount don't apply.
 */
export function CustomInvoicesRoutes() {
  return (
    <Routes>
      <Route index element={<CustomInvoicesPage />} />
      <Route path=":id" element={<CustomInvoiceDetail />} />
      <Route path=":id/print" element={<CustomInvoicePrint />} />
    </Routes>
  );
}
